// Step thresholds based on Figma designs - keys match i18n path names
export const PROCESSING_STEPS = {
  ProcessingFileStep: 0,
  FindingInFileStep: 10,
  DiggingInFileStep: 50,
} as const;

export type ProcessingStep = keyof typeof PROCESSING_STEPS;

export const DEFAULT_STEP: ProcessingStep = 'ProcessingFileStep';

// File size thresholds in bytes
export const BIG_FILE_SIZE = 3_000_000; // 3 MB
export const MEDIUM_FILE_SIZE = 1_000_000; // 1 MB

// Duration thresholds in ms - bigger files take longer to simulate progress
export const SMALL_FILE_DURATION_MS = 30_000; // 30 seconds for small files
export const MEDIUM_FILE_DURATION_MS = 60_000; // 1 minute for medium files
export const BIG_FILE_DURATION_MS = 120_000; // 2 minutes for big files

// Progress simulation constants
export const MAX_SIMULATED_PROGRESS = 99; // Stall at 99% if API is still processing
export const INTERVAL_MS = 100; // Update every 100ms for smooth animation

export const I18N_BASE_PATH = 'ProcessingFile';
